export const environment = {
    production: false,
    x_api_key:'BRvzhEQZND9dK8zmNz3GI9KY27gIkCOl4K326WAa',
    generate_x_api_key:'ES02LApNBE54N2mFeAfZd2NdeJRbepZK27MTu3fj',
    client_id: '40mespf7e3rvtekat75g3b0j8o',
    client_secret: '1mu9jm8v8l1l0kl7s6h51m09h4e6ilqrltkp2d5l6rufvh0lm2a1',
    grant_type:'client_credentials',
    cognito_endpoint:'https://fcacorptest.auth.us-east-1.amazoncognito.com/oauth2/token',
    x_api_key_saveData:'vxm1JWXFH18JXM9s5cvUc1G0ke2yCFm01YhsytiL',
    api_gateway_generateOTP:'https://mmletqif81.execute-api.us-east-1.amazonaws.com/dev/genearte',
    api_gateway_validateOTP:'https://mmletqif81.execute-api.us-east-1.amazonaws.com/dev/validate',
    api_gateway_saveReportData:'https://zq3323yfa8.execute-api.us-east-1.amazonaws.com/dev/savedata',
    generate:'https://zij7iirxnd.execute-api.us-east-1.amazonaws.com/dev/generate',
};
